<template>
  <v-container>
    <v-row>
      <v-col>
        <h1>First Timer Welcome Gift</h1>
        <h2 class="mb-3">Ra Yoga Journals</h2>
        <customer-journal-table />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import CustomerJournalTable from '../components/customer-journal/CustomerJournalTable.vue'
export default {
  components: { CustomerJournalTable },
  name: 'CustomerJournalPage',
}
</script>

<style>

</style>